import { AGENCY_PUBLISHERS_LIST_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
// import mixpanel from 'root/src/client/logic/analytics/mixpanel'
// import { mixpanelEvents } from 'root/src/shared/fixtures/mixpanel'
import { brandSettingsBase } from 'root/src/client/logic/brandSettings/thunks/setBrandSettings'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { agencyEndpointIds } from 'root/src/shared/agency/agency.constants'

export default formData => async (dispatch, getState) => {
	await brandSettingsBase(dispatch, getState, formData, agencyEndpointIds.ADD_AGENCY_PUBLISHER)
	// TODO do we add mixpanel here?
	// mixpanel.track(mixpanelEvents.publisherDetails)
	await dispatch(apiRequest(agencyEndpointIds.GET_AGENCY_PUBLISHERS))
	return pushRouteClient({ routeId: AGENCY_PUBLISHERS_LIST_ROUTE_ID })
}
